import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

function Banner() {
  return (
    
    <Head>
      <h5>ATTENTION: The API that serves this application is no longer available.</h5>
      <p>Major functionality of this app is therefore deprecated. The supplement information being displayed is static and for demo purposes only.</p>
    </Head>
  )
}

export default Banner

const Head = styled.div`
  padding-top: 10px;  
  height: fit-content;
  background-color: #FF0000;
  color: white;
  border-radius: 10px;
  p {
    padding-bottom: 10px;
    font-size: 12px;
  }
}
`
